// @flow
import * as React from 'react'

import './FormSuccessAlert.scss'

export type Props = {
  children: React.Node,
}

export default class FormSuccessAlert extends React.Component<Props> {
  render = () => {
    return <div className="FormSuccessAlert">{this.props.children}</div>
  }
}
